import { cleanObject } from './object';


export const getFormDataFromObject = (data: Record<string, any>): FormData => {
  const formData = new FormData();
  const cleanData = cleanObject(data);

  const appendFormData = (formData: FormData, value: any, key: string) => {
    if (value instanceof Date || value instanceof Blob || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      formData.append(key, value as any);
    } else if (Array.isArray(value)) {
      value.forEach((v, index) => {
        appendFormData(formData, v, `${key}[${index}]`);
      });
    } else if (typeof value === 'object' && value !== null) {
      Object.keys(value).forEach(subKey => {
        appendFormData(formData, value[subKey], `${key}[${subKey}]`);
      });
    }
  };

  Object.keys(cleanData).forEach(key => {
    appendFormData(formData, cleanData[key], key);
  });

  return formData;
};
